export enum EmailTemplate {
    Registration = 1,
    Password = 2,
    DeleteEmployee = 3,
    Reminder = 4
}